import { getPointInfo, getNegativePoints } from "../../services/contentService";
import {
  SET_POINT_DATA,
  SET_NEGATIVE_MANUEL_POINTS,
  SET_EXPIRED_POINTS,
} from "./appSlice";

export const fetchPointDataAction = () => async (dispatch) => {
  try {
    const negativePoints = await getNegativePoints();
    dispatch(
      SET_NEGATIVE_MANUEL_POINTS({
        ks: negativePoints.totalManuelKs,
        kk: negativePoints.totalManuelKK,
        total: negativePoints.totalManuelKs + negativePoints.totalManuelKK,
      })
    );

    const pointData = await getPointInfo();

    pointData.records.forEach((item) => {
      item.createdAt = item?.createdAt?.toString();
      item.expiration_date = item?.expiration_date?.toString();
      item.user = item?.user?.toJSON ? item.user.toJSON() : item.user;
      item.giver = item?.giver?.toJSON ? item.giver.toJSON() : item.giver;
      item.reason = item?.reason || null;
    });

    pointData.groups = {
      ksPoint: 0,
      kkPoint: 0,
      survey: { kk: 0, ks: 0 },
      exam: { kk: 0, ks: 0 },
      beingOnline: { kk: 0, ks: 0 },
      manuel: { kk: 0, ks: 0 },
      liveBroadcast: { kk: 0, ks: 0 },
    };

    pointData.records.forEach((item) => {
      if (typeof item.kk_amount === "number") {
        pointData.groups.ksPoint += Number(item.ks_amount);
      }
      if (typeof item.ks_amount === "number") {
        pointData.groups.kkPoint += Number(item.kk_amount);
      }

      switch (item.resource) {
        case "Siteye Giriş":
          pointData.groups.beingOnline.kk += Number(item.kk_amount);
          pointData.groups.beingOnline.ks += Number(item.ks_amount);
          break;
        case "Anket":
          pointData.groups.survey.kk += Number(item.kk_amount);
          pointData.groups.survey.ks += Number(item.ks_amount);
          break;
        case "Bilgi Küpü":
          pointData.groups.exam.kk += Number(item.kk_amount);
          pointData.groups.exam.ks += Number(item.ks_amount);
          break;
        case "Manuel":
          if (item.type === "negative") break;
          pointData.groups.manuel.kk += Number(item.kk_amount);
          pointData.groups.manuel.ks += Number(item.ks_amount);
          break;
        case "Canlı Yayın":
          pointData.groups.liveBroadcast.kk += Number(item.kk_amount);
          pointData.groups.liveBroadcast.ks += Number(item.ks_amount);
          break;
        default:
          break;
      }
    });
    
    dispatch(SET_POINT_DATA(pointData));
    dispatch(
      SET_EXPIRED_POINTS({
        expired: pointData.expire_points || 0,
        expireKS: pointData.expireKS || 0,
        expireKK: pointData.expireKK || 0,
      })
    );
  } catch (error) {
    console.error("fetchPointDataAction error:", error);
    throw error;
  }
};
